export default {
  name: 'guy-image',
  props: ['orders']
}